
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Communication digitale, définition et enjeux pour les entreprises",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "La communication digitale est essentielle aujourd'hui. Découvrez ce qu’elle implique et pourquoi elle est cruciale pour toucher votre audience en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Définition : la communication digitale, c’est quoi ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "La communication à l’ancienne ne suffit plus. Vous devez communiquer avec le digital. Mais qu’est-ce donc ? Cet article vous explique tout !",
        },
      ],
    };
  },
};
